import { OnboardingStep } from "../types";
import { EDDQuestionnaire } from "../components/EDDQuestionnaire/EDDQuestionnaire";

export const AdditionalInformation: React.FC<OnboardingStep> = ({
  title,
  onNext,
  onSkip
}) => {
  return (
    <EDDQuestionnaire onSubmit={onNext} onCancel={onSkip} isLoading={false} />
  );
};
